import lodash from 'lodash';
import { metadata } from 'lib_ui-services';
import useFormContext from './useFormContext';

export default function useHiddenForValue(hNode, conditions = hNode.hiddenForValue) {
    const form = useFormContext();
    // Use the enclosing form's edits, not the grid selection. NestedObject supplies
    // propertyPath for fields belonging to an object or array item.
    const record = hNode.propertyPath ? lodash.get(form.newRecord, hNode.propertyPath) : form.newRecord;
    return metadata.isHiddenForValue(conditions, record, form.state?.context);
}
